import ReactDOM from 'react-dom'
import moment from 'moment'
import util from './util'
import * as auth from './auth'
import message from './message'
import * as number from './number'
import * as image from './image'
import * as file from './file'
import link from './link'
import request from './request'
import base from './base'
import track from './track'
import dyTrackUtil from './dyTrack'
import { renderCompat, renderCompatPromise, renderToBody } from './renderCompat'

export {
  util,
  auth,
  message,
  number,
  request,
  base,
  link,
  image,
  file,
  track,
  dyTrackUtil,
  renderCompat,
  renderCompatPromise,
  renderToBody
}

export const isDark = (bgColor) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(bgColor)
  const darkness = 1 - (0.299 * parseInt(result[1], 16) + 0.587 * parseInt(result[2], 16) + 0.114 * parseInt(result[3], 16)) / 255
  // darkness < 0.5 为浅色模式
  return darkness > 0.3
}
export const isWhite = (colorStr) => {
  if (!colorStr) return false
  if (/#([\d\w]{3,6})/.test(colorStr)) {
    const str = colorStr.replace('#', '').toUpperCase()
    return str === 'FFF' || str === 'FFFFFF'
  }
  const rgbMatch = colorStr.match(/rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/)
  if (rgbMatch.length > 0) {
    return rgbMatch[1] === '255' && rgbMatch[2] === '255' && rgbMatch[3] === '255'
  }
  return false
}
// 处理日期
export function dealDate(date, showDetail = true) {
  if (!date) return
  return showDetail ? date.split('.')[0] : date.split(' ')[0]
}

export function destroy(resolve, div, val) {
  const unmountResult = ReactDOM.unmountComponentAtNode(div)
  if (unmountResult && div.parentNode) {
    div.parentNode.removeChild(div)
    resolve(val)
  }
}

export function getAllUrlParam(removeDate = false) {
  // const defaultDateRange = hasAuth('query_one_year') || hasAuth('ai_data_query_two_year') ? DateRangeButton.LAST_1_YEAR : DateRangeButton.LAST_3_MONTH
  const query = window.location.search.substring(1)
  const params = query.split('&')
  const allParams = {}
  if (!removeDate) {
    allParams.startDate = moment().subtract(30, 'd')
    allParams.endDate = moment().subtract(1, 'd')
  }
  for (let i = 0; i < params.length; i++) {
    const tmp = params[i].split('=')
    let fieldName = decodeURIComponent(tmp[0])
    if (fieldName.includes('[]')) {
      // 如果是数组参数的情况
      fieldName = fieldName.replace('[]', '')
      if (allParams[fieldName]) {
        allParams[fieldName].push(decodeURIComponent(tmp[1]))
      } else {
        allParams[fieldName] = [decodeURIComponent(tmp[1])]
      }
    } else {
      allParams[fieldName] = decodeURIComponent(tmp[1])
    }
  }
  return allParams
}

export function uuid() {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now() // use high-precision timer if available
  }
  const _uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c == 'x' ? r : ((r & 0x3) | 0x8)).toString(16)
  })
  return _uuid
}
